import React, { createContext, useContext, useState, useEffect } from 'react';
import { changeLanguage as triggerGoogleTranslate } from '../utils/googleTranslate';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Get initial language from localStorage or default to 'en'
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'en';
  });
  
  const [isTranslating, setIsTranslating] = useState(false);

  // Save language to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const toggleLanguage = () => {
    // Prevent multiple clicks
    if (isTranslating) return;
    
    setIsTranslating(true);
    const newLanguage = language === 'en' ? 'es' : 'en';
    
    // Update local state first
    setLanguage(newLanguage);
    
    // Force save to localStorage before reload happens
    // (useEffect might be too slow before location.replace kills the page)
    localStorage.setItem('language', newLanguage);
    
    // Trigger Google Translate (which will reload the page)
    triggerGoogleTranslate(newLanguage);
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    isTranslating,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
